export * from "./detectEthProvider";
